import {links, homeLink} from '../common';
import * as css from './desktop.scss';
import Columns from './components/Columns/Columns';

export default ({config, mainLinks, socialLinks, t, tAll}) => `
  <nav class="${css.contentWrapper}">
    ${Columns(mainLinks)}
    <div class="${css.aside}">
      <a
        href="${homeLink(config.language)}"
        class="${css.asideLogo}"
        title="${tAll('title_wix_logo')}"
        tabindex="${config.tabIndex[1]}"
        data-hook="footer-wix-logo"
      >
        Wix.com
      </a>
      <p class="${css.asideParagraph}" data-hook="description">${t(
  'description',
)}</p>
      <p class="${css.asideParagraph}" data-hook="closing_line">${t(
  'closing_line1',
)} ${t('closing_line2')}</p>
      <p class="${css.asideParagraph}" data-hook="closing_years">${t(
  'closing_years',
)}</p>
      ${links(
    socialLinks,
    {
      list: css.social,
      item: css.socialItem,
      itemContent: css.socialItemContent,
    },
    null,
    config.tabIndex[1],
  )}
    </div>
  </nav>
`;
